export default __webpack_public_path__ + "images/57_2_image.jpg";